import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Mail, Send, CheckCircle2 } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import api from '@/lib/api';
import { trackEvent } from './GA4';

export default function NewsletterForm({ source = 'footer', variant = 'compact' }) {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !/^.+@.+\..+$/.test(email)) { toast.error('Email non valida'); return; }
    setBusy(true);
    try {
      const r = await api.post('/public/newsletter/subscribe', { email, source });
      setDone(true);
      trackEvent('newsletter_subscribe', { source });
      toast.success(r.data?.message || 'Iscrizione completata');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Errore. Riprova.');
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="flex items-center gap-2 text-emerald-300 text-sm" data-testid={`newsletter-success-${source}`}>
        <CheckCircle2 className="w-5 h-5" />
        <span>{t('newsletter.success')}</span>
      </div>
    );
  }

  const inline = variant === 'inline';
  return (
    <form onSubmit={submit} className={inline ? 'flex flex-col sm:flex-row gap-2' : 'flex gap-2'} data-testid={`newsletter-form-${source}`}>
      <div className="relative flex-1">
        <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[color:var(--text-subtle)]" />
        <Input data-testid={`newsletter-email-${source}`} type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t('newsletter.placeholder')} required className="pl-9 bg-[color:var(--surface-2)] border-[color:var(--border-c)]" />
      </div>
      <Button data-testid={`newsletter-submit-${source}`} type="submit" disabled={busy} className="bg-[color:var(--gold-strong)] hover:bg-[#C6A21A] text-black font-semibold btn-press">
        <Send className="w-4 h-4 mr-2" /> {busy ? '…' : t('newsletter.button')}
      </Button>
    </form>
  );
}
